import Typography from "components/typography";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Img1 from "images/png/promo-card-img/select-release.png";
import Img2 from "images/png/promo-card-img/pick-card.png";
import Img3 from "images/png/promo-card-img/share.png";

const HowItWorks = () => {
  return (
    <section>
      <Typography
        align="center"
        size="3.6rem"
        weight="semibold"
        mb="2"
        m_size="4xl"
      >
        How It Works?
      </Typography>
      <Typography align="center" size="2xl" color="#4E4E4E" mb="10" m_size="lg">
        Boost Your Music with Custom Promo Cards!
      </Typography>
      <Grid>
        <GridItem>
          <Typography
            m_size="3xl"
            m_mb="1.6"
            size="4rem"
            weight="bold"
            mb="2.4"
          >
            Select Your Release
          </Typography>
          <Typography
            size="lg"
            m_lh="2.1rem"
            color={Colors.grey400}
            lh="2.5rem"
          >
            Choose a single, album, or EP from your Rated Afrika library to
            generate a custom promo card.
          </Typography>
        </GridItem>
        <GridItem>
          <GridImage src={Img1} alt="select-release-image" />
        </GridItem>
        <GridItem>
          <GridImage src={Img2} alt="pick-card-image" />
        </GridItem>
        <GridItem>
          <Typography
            m_size="3xl"
            m_mb="1.6"
            size="4rem"
            weight="bold"
            mb="2.4"
          >
            Pick A Card
          </Typography>
          <Typography
            size="lg"
            m_lh="2.1rem"
            color={Colors.grey400}
            lh="2.5rem"
          >
            Pick from various designs, colors, and layouts to match your brand
            and aesthetic.
          </Typography>
        </GridItem>
        <GridItem>
          <Typography
            m_size="3xl"
            m_mb="1.6"
            size="4rem"
            weight="bold"
            mb="2.4"
          >
            Download & Share
          </Typography>
          <Typography
            size="lg"
            m_lh="2.1rem"
            color={Colors.grey400}
            lh="2.5rem"
          >
            Instantly download your promo card and share it on all social media
            platforms and more to promote your music.
          </Typography>
        </GridItem>
        <GridItem>
          <GridImage src={Img3} alt="share-image" />
        </GridItem>
      </Grid>
    </section>
  );
};

export default HowItWorks;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 35% 35%;
  align-items: center;
  justify-content: space-between;
  grid-row-gap: 2.4rem;
  @media only screen and (max-width: 769px) {
    padding: 0 2rem;
    grid-template-columns: 100%;
    & :nth-child(3) {
      order: 4;
    }
    & :nth-child(4) {
      order: 3;
    }
    & :nth-child(5) {
      order: 5;
    }
    & :nth-child(6) {
      order: 6;
    }
  }
`;

const GridItem = styled.div`
  width: 100%;
  @media only screen and (max-width: 769px) {
    display: flex;
    flex-direction: column;
  }
`;
const GridImage = styled.img`
  width: 50rem;
  @media only screen and (max-width: 769px) {
    width: 35rem;
    margin-left: auto;
    margin-right: auto;
  }
`;
